import {
  REPORT_TRANSACTION,
  REPORT_TRANSACTION_DETAIL,
  EXPORT_TRANSACTION
} from './constants'

/****************************************************************
 * Transaction API
 ****************************************************************/

/**
 * @param {object} query query params
 * @return {Axios.IPromise<U>}
 */
export function getTransactions (query) {
  return axios.get(REPORT_TRANSACTION, {params: query, withCredentials: true})
    .then((response) => {
      return Promise.resolve(response)
    })
    .catch((error) => {
      let {response} = error
      return Promise.reject(response)
    })
}
/**
 *
 * @param {int} transactionId
 * @param {object} query
 * @return
 */
export function getTransactionDetail (transactionId, query) {
  return axios.get(REPORT_TRANSACTION_DETAIL(transactionId), {params: query, withCredentials: true})
    .then((response) => {
      return Promise.resolve(response)
    }).catch((error) => {
      let {response} = error
      return Promise.reject(response)
    })
}

export function exportTransaction (query) {
  return axios.get(EXPORT_TRANSACTION, {params: query, withCredentials: true})
    .then((response) => {
      return Promise.resolve(response)
    }).catch((error) => {
      if (error.response) {
        let eobj = new Error(error.response.errors)
        return Promise.reject(eobj)
      }
      return Promise.reject(error)
    })
}



// WEBPACK FOOTER //
// ./app/api/reports.js